import {
  AUTH_LOGIN_OK,
  AUTH_LOGIN_ERROR,
  AUTH_LOGOUT_OK,
  AUTH_UNAUTHORIZED,
  INIT_USERINFO_FROM_LOCAL,
  AUTH_UPDATE_USER_INFO,
  UPDATE_UNREAD_NUMBER
} from '../../action-types';
import { storageInfo } from '../../../utils/storageUtils';

const initialState = {
  //登录以后拿到的用户信息
  userInfo: null,
  unReadNumber:0,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN_OK:
      //拿获取到的值覆盖原来的值
      return {
        ...state,
        userInfo: action.payload,
      };
    case AUTH_LOGIN_ERROR:
      //重新赋值错误信息
      return { ...state, userInfo: {}};
    case AUTH_LOGOUT_OK:
      //退出登录，清除本地存储的用户信息
      storageInfo.delUserInfo();
      return { ...state, userInfo: null };
    case INIT_USERINFO_FROM_LOCAL:
      // 从本地初始化用户信息到redux
      return { ...state, userInfo: action.payload };
    case AUTH_UNAUTHORIZED:
      //未授权401，清除存储在本地的用户信息，弹出登录框
      storageInfo.delUserInfo();
      return { ...state, userInfo: null };
    case UPDATE_UNREAD_NUMBER:
      return {...state,unReadNumber: action.payload};
    case AUTH_UPDATE_USER_INFO:
      //更新用户信息
      return { ...state, userInfo: action.payload };
    default:
      return state;
  }
};

export default authReducer;
